import React, { Fragment, FC } from 'react'
import { Field } from 'formik'
import { ThunkCreator } from 'easy-peasy'
import { UseAsyncReturn } from 'react-async-hook'
import { GoogleAutoCompleteResult } from '@mortgage-pos/types'
import { ElementTrackingPayload } from '@mortgage-pos/ui/store/tracking'
import { ComboBox } from './Combobox'
import InfoBlock from '@mortgage-pos/ui/components/InfoBlock'

interface Props {
  name: string
  handleInputChange: (e: React.ChangeEvent<HTMLInputElement>, fn: any) => void
  results: UseAsyncReturn<GoogleAutoCompleteResult, string[]>
  inputText: string
  setInputText: (string) => void
  setEnterAddressManually: (boolean) => void
  elementClicked: ThunkCreator<ElementTrackingPayload, any>
  addressFields: string[]
}

export const AutoCompleteField: FC<Props> = ({
  name,
  handleInputChange,
  results,
  inputText,
  setInputText,
  setEnterAddressManually,
  elementClicked,
  addressFields,
}) => {
  return (
    <Field name={name} autoComplete="off">
      {({
        field: { onChange: formikChange },
        meta: { value, error, touched },
        form: { setFieldValue },
      }) => {
        return (
          <Fragment>
            <ComboBox
              name={name}
              onChange={(e) => {
                formikChange(e)
                handleInputChange(e, setFieldValue)
              }}
              value={value}
              setFieldValue={setFieldValue}
              results={results}
              inputText={inputText}
              addressFields={addressFields}
              error={error}
              touched={touched}
              setInputText={setInputText}
              setEnterAddressManually={setEnterAddressManually}
              elementClicked={elementClicked}
            />
            {error && touched ? (
              <InfoBlock type="danger">{error}</InfoBlock>
            ) : null}
          </Fragment>
        )
      }}
    </Field>
  )
}
